
export default date => {
    const keys = new Array(31).fill(1).reduce((a, b, i) => ({ ...a, [`m${i + 1}`]: 0 }), {});
    return [
        {
            name: "最优价格",
            total: 0,
            sort: 0,
            ...keys
        }, {
            name: "商务协议散客",
            total: 0,
            sort: 1,
            ...keys
        }, {
            name: "政府协议散客",
            total: 0,
            sort: 2,
            ...keys
        }, {
            name: "套餐",
            total: 0,
            sort: 3,
            ...keys
        }, {
            name: "旅行社",
            total: 0,
            sort: 4,
            ...keys
        }, {
            name: "电子商务",
            total: 0,
            sort: 5,
            ...keys
        }, {
            name: "折扣价",
            total: 0,
            sort: 6,
            ...keys
        }, {
            name: "公司团",
            total: 0,
            sort: 7,
            ...keys
        }, {
            name: "旅行团",
            total: 0,
            sort: 8,
            ...keys
        }, {
            name: "合同",
            total: 0,
            sort: 9,
            ...keys
        }, {
            name: "其他",
            total: 0,
            sort: 10,
            ...keys
        }, {
            name: "Pickup总计",
            total: 0,
            sort: 11,
            ...keys
        }
    ].map(x => ({ ...x, code: x.name }))
}



// WEBPACK FOOTER //
// ./src/components/table/4.0/4-2/4.2.6/data.js